module.exports = __webpack_public_path__ + "img/exam-photo.45264757.png";